/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartDimensionDto } from './PartDimensionDto';
import {
    PartDimensionDtoFromJSON,
    PartDimensionDtoFromJSONTyped,
    PartDimensionDtoToJSON,
    PartDimensionDtoToJSONTyped,
} from './PartDimensionDto';

/**
 * 
 * @export
 * @interface PartDto
 */
export interface PartDto {
    /**
     * 
     * @type {number}
     * @memberof PartDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDto
     */
    partTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDto
     */
    manufacturerId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    externalId?: string;
    /**
     * 
     * @type {Array<PartDimensionDto>}
     * @memberof PartDto
     */
    partDimensions?: Array<PartDimensionDto>;
}

/**
 * Check if a given object implements the PartDto interface.
 */
export function instanceOfPartDto(value: object): value is PartDto {
    return true;
}

export function PartDtoFromJSON(json: any): PartDto {
    return PartDtoFromJSONTyped(json, false);
}

export function PartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partTypeId': json['partTypeId'] == null ? undefined : json['partTypeId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'partDimensions': json['partDimensions'] == null ? undefined : ((json['partDimensions'] as Array<any>).map(PartDimensionDtoFromJSON)),
    };
}

export function PartDtoToJSON(json: any): PartDto {
    return PartDtoToJSONTyped(json, false);
}

export function PartDtoToJSONTyped(value?: PartDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partTypeId': value['partTypeId'],
        'manufacturerId': value['manufacturerId'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'externalId': value['externalId'],
        'partDimensions': value['partDimensions'] == null ? undefined : ((value['partDimensions'] as Array<any>).map(PartDimensionDtoToJSON)),
    };
}

